const CheckGreen = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.12604 1.26617C5.6195 1.7727 5.11755 2.00787 4.3954 2.00787C3.76485 2.00787 2.86775 1.88558 2.375 2.38248C1.88614 2.87545 2.00789 3.76885 2.00789 4.39538C2.00789 5.11755 1.7727 5.6195 1.26615 6.12605C0.422056 6.97015 7.29538e-06 7.3922 0 7.91665C1.29807e-05 8.4411 0.422067 8.8632 1.26617 9.70729C1.83362 10.2747 2.00789 10.6411 2.00789 11.4379C2.00789 12.0685 1.8856 12.9656 2.38251 13.4583C2.87548 13.9472 3.76887 13.8254 4.39538 13.8254C5.16443 13.8254 5.53477 13.9759 6.08362 14.5247C6.55098 14.9921 7.17748 15.8333 7.91669 15.8333C8.65587 15.8333 9.28237 14.9921 9.74972 14.5247C10.2986 13.9759 10.6689 13.8254 11.4379 13.8254C12.0645 13.8254 12.9579 13.9472 13.4508 13.4583C13.9477 12.9656 13.8254 12.0685 13.8254 11.4379C13.8254 10.6411 13.9997 10.2747 14.5672 9.70729C15.4113 8.8632 15.8333 8.4411 15.8333 7.91665C15.8333 7.3922 15.4113 6.97015 14.5672 6.12605C13.9997 5.55859 13.8254 5.19221 13.8254 4.39538C13.8254 3.76484 13.9477 2.86776 13.4509 2.375C12.9579 1.88612 12.0645 2.00787 11.4379 2.00787C10.7156 2.00787 10.2137 1.77259 9.7073 1.26617C8.86319 0.422056 8.44113 1.50939e-07 7.91667 0C7.3922 2.01252e-07 6.97015 0.422056 6.12604 1.26617Z"
      fill="#32E886"
    />
    <path
      d="M4.91797 8.63128C4.91797 8.63128 6.11797 9.15272 6.71797 9.91699C6.71797 9.91699 8.51797 6.91699 10.918 5.91699"
      stroke="#141B34"
      stroke-width="1.1875"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default CheckGreen;
